import React from "react";
import "./LineChartParts.css";

/**
 * Legend for the call-average line chart.
 *
 * It wraps instead of overflowing (an employee can easily carry a dozen
 * products) and each entry is a button: clicking one hides that product so a
 * crowded chart can be read a line at a time. The text label is what carries
 * identity here - the swatch only reinforces it.
 */
const LineChartLegend = ({ payload = [], hidden = [], onToggle }) => {
  if (!payload.length) {
    return null;
  }

  return (
    <div className="lc-legend">
      {payload.map((entry) => {
        const key = entry.dataKey ?? entry.value;
        const isHidden = hidden.includes(key);
        return (
          <button
            type="button"
            key={key}
            className={`lc-legend__item${isHidden ? " is-hidden" : ""}`}
            onClick={() => onToggle && onToggle(key)}
            aria-pressed={!isHidden}
            title={isHidden ? `Show ${entry.value}` : `Hide ${entry.value}`}
          >
            <span
              className="lc-legend__swatch"
              style={{ backgroundColor: entry.color }}
              aria-hidden="true"
            />
            <span className="lc-legend__label">{entry.value}</span>
          </button>
        );
      })}
    </div>
  );
};

export default LineChartLegend;
